// extracted by mini-css-extract-plugin
export default {"ButtonComponent":"Menu_ButtonComponent__AHQ7H","MenuComponent":"Menu_MenuComponent__wf+1s","MenuWrapper":"Menu_MenuWrapper__+TcIt"};